import script from "./DisplayUserTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplayUserTooltip.vue?vue&type=script&setup=true&lang=js"

import "./DisplayUserTooltip.vue?vue&type=style&index=0&id=08ae44a7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08ae44a7"]])

export default __exports__